import ConfirmationModal from 'components/ui/ConfirmationModal/confirmation-modal';
import Container from 'components/ui/Container';
import Modal from 'components/ui/Modal/modal';
import PrimaryButton from 'components/ui/PrimaryButton';
import SecondaryButton from 'components/ui/SecondaryButton';
import { useFormik } from 'formik';
import useToggle from 'hooks/useToggle';
import { useState } from 'react';
import Select from 'react-select';
import { toast } from 'react-toastify';
import {
  useCreateAttendanceMutation,
  useDeleteAttendanceMutation,
  useListDailySessionQuery,
  useUpdateAttendanceMutation
} from 'redux/reducers/attendance';

import {
  attendanceInitialValues,
  mannualattendanceInitialValues,
  MannualAttendanceSchemaValidations
} from './schema';

import moment from 'moment';
import 'react-date-range/dist/styles.css'; // main css file
import 'react-date-range/dist/theme/default.css'; // theme css file
import { useListTrainingCourseQuery } from 'redux/reducers/training';
import OrganizationForm from './AttendanceForm';
import AttendanceTable from './AttendanceTable';
import { ActionType } from 'utils/action.type.enum';
import { useGetAllRoutineList } from 'service/admin.query';

const Attendance = () => {
  const [formModal, setFormModal] = useToggle(false);
  const [deleteModal, toggleDeleteModal] = useToggle(false);

  const [attendanceInitialFormState, setAttendancenitialForm] = useState(attendanceInitialValues);
  const [deletingAttendanceState, setDeletingAttendance] = useState<any | null>(null);

  const [deleteAttendance, { isLoading: isDeleting }] = useDeleteAttendanceMutation();
  const [createAttendance, { isLoading: isCreating }] = useCreateAttendanceMutation();
  const [updateAttendance, { isLoading: isUpdating }] = useUpdateAttendanceMutation();
  // const { data: trainingData, isLoading } = useListTrainingCourseQuery();

  const {data: trainingData=[], isLoading}=useGetAllRoutineList()
  const [selectedDailySession, setSelectedDailySession] = useState<any>(null);

  const [selectedTrainning, setselectedTrainning] = useState<any>();
  const [selectedDate, setSelectedDate] = useState<any>('');





  const formik = useFormik({
    enableReinitialize: true,
    validationSchema: MannualAttendanceSchemaValidations,
    initialValues: mannualattendanceInitialValues,
    onSubmit: (values, { resetForm }) => {
      const bulkPayload = values.selectedUsers.map((user_id: number) => ({
        // routine_id: values.routine_id,
        // day_session_id: 0,
        // user_id: user_id,
        // attendance_date: values.attendance_date + 'T00:00:00.000Z',
        // status: 1

        source: 'manual',
        reason: '',
        branch_code: '',
        temperature: 0,
        verify_type: false,
        verify_time: "",
        status: true,
        check_in: '',
        check_out: '',
        approved_date: values?.requested_date ? values.requested_date + 'T00:00:00.000Z' : moment().format(),
        requested_date: values?.requested_date ? values.requested_date + 'T00:00:00.000Z' : moment().format(),
        user_id: user_id,
        approved_by_id: 0,
        hall_id: 0,
        day_session_id: 0,
        routine_id: values.routine_id,
      }));

      let executeFunc = createAttendance;

      executeFunc(bulkPayload)
        .unwrap()
        .then(() => {
          toast.success('Bulk attendance created successfully!');
          resetForm();
          setAttendancenitialForm(attendanceInitialValues);
          setFormModal(false);
        })
        .catch((err: any) => {
          console.error('Bulk attendance error:', err);
          toast.error(err?.data?.message || 'Failed to create attendance');
        });
    }
  });

  const selectionRange = {
    startDate: new Date(),
    endDate: new Date(),
    key: 'selection'
  };
  const [state, setState] = useState<Array<typeof selectionRange>>([selectionRange]);
  const handleSelect = (date: any) => {
    setState([date.selection]);
  };
  const start_date = moment(state[0].startDate);
  const end_date = moment(state[0].endDate);

  const [open, setOpen] = useState(false);
  const onEditClicked = (data: any) => {
    setAttendancenitialForm(data);
    setOpen(!open);
  };

  const onDeleteConfirm = () => {
    deletingAttendanceState &&
      deleteAttendance(deletingAttendanceState?.attendance_id)
        .unwrap()
        .then((data: any) => {
          toast.success('Deleted Successfully');
          setAttendancenitialForm(attendanceInitialValues);
          toggleDeleteModal();
        })
        .catch((err: any) => {
          toast.error('Error');
        });
  };

  const handleUpdateConfirm = () => {
    const payload: any = { ...attendanceInitialFormState };
    payload.status = attendanceInitialFormState.status == 1 ? 0 : 1;
    updateAttendance(payload)
      .unwrap()
      .then((data: any) => {
        toast.success('Updated Successfully');
        setAttendancenitialForm(attendanceInitialValues);
        setOpen(false);
      })
      .catch((err: any) => {
        toast.error(err?.error?.Data?.message ?? 'Error');
      });
  };

  const onDeleteClicked = (data: any) => {
    setDeletingAttendance(data);
    toggleDeleteModal();
  };



  return (
    <Container
      title="Attendance Management"
      subTitle="List of all attendance"
      btnTitle="Add Attendance"
      module_code='AM'
      actionType={ActionType.CAN_ADD}
      OnBackClicked={() => {
        setFormModal();
      }}>
      <ConfirmationModal
        size="modal-sm"
        isOpen={open}
        onClose={() => {
          setOpen(false);
        }}
        btnText="Change Status"
        onConfirm={handleUpdateConfirm}
        title="Attendance Confirmations"
        isLoading={isDeleting}>
        <>
          <div className=" pt-2 fs-15 ">
            <h4>Are you Sure ?</h4>
            <p className="text-muted ">
              You want to change
              <span className="fs-4">
                &nbsp;
                {attendanceInitialFormState.status == 1 ? 'Present' : 'Absent'}
                &nbsp;
              </span>
              &nbsp; to &nbsp;
              <span className="fs-4">
                &nbsp;
                {attendanceInitialFormState.status == 1 ? 'Absent' : 'Present'}
                &nbsp;
              </span>
              Record ?
            </p>
          </div>
        </>
      </ConfirmationModal>
      <ConfirmationModal
        isOpen={deleteModal}
        onClose={toggleDeleteModal}
        onConfirm={onDeleteConfirm}
        title="Delete Confirmations"
        isLoading={isDeleting}>
        <>
          <div className="mt-4 pt-2 fs-15 mx-4 mx-sm-5">
            <h4>Are you Sure ?</h4>
            <p className="text-muted ">You want to Remove this Record ?</p>
          </div>
        </>
      </ConfirmationModal>
      <AttendanceTable
        tableHeaders={() => (
          <div className="d-flex align-items-end gap-3">
            <div>
              <input
                type="date"
                placeholder="Training date"
                className="form-control"
                value={selectedDate}
                onChange={(e: any) => setSelectedDate(e.target.value)}
              />
            </div>

            <div style={{ maxWidth: '260px', minWidth: '290px' }}>
              <Select
                options={trainingData?.map((item: any) => ({
                  label: `${item?.training_name} -${item.batch_name}-${item.hall_name}`,
                  value: item?.routine_master_id
                }))}
                placeholder="Select Routine"
                value={selectedTrainning}
                onChange={(item: any) =>{
                  if(item?.value){

                    
                    setselectedTrainning({
                      label: item?.label,
                      value: item?.value
                    })
                  }else{
                       setselectedTrainning({
                      label: "",
                      value: ""
                    })
                  }
                }
                }
                isClearable
              />
            </div>

            {/* <div style={{ minWidth: '200px' }}>
              <Select
                placeholder="Select Session"
                value={selectedDailySession}
                onChange={(option) => {
                  setSelectedDailySession(option);
                  // formik.setFieldValue('day_session_id', option?.value || null);
                }}
                options={dailySessionData?.data?.map((item: any) => ({
                  label: `${item.altered_start_time} - ${item.altered_end_time}`,
                  value: item.id
                }))}
                isClearable
              />
            </div> */}
          </div>
        )}
        onEditClicked={onEditClicked}
        onDeleteClicked={onDeleteClicked}
        startDate={moment(selectedDate)}
        endDate={end_date}
        selectedTraining={selectedTrainning?.value}
        selectedSession={selectedDailySession?.value}
      />

      <form onSubmit={formik.handleSubmit}>
        <Modal
          title="Create New Attendance"
          isModalOpen={formModal}
          modalSize='modal-xl'
          closeModal={setFormModal}
          renderFooter={() => (
            <div className="hstack gap-2 justify-content-end">
              <SecondaryButton
                onClick={setFormModal}
                title="Close"
                isLoading={isUpdating || isCreating}
              />
              <PrimaryButton
                title="Add Attendance"
                iconName="ri-add-line align-bottom me-1"
                type="submit"
                isLoading={isUpdating || isCreating}
              />
            </div>
          )}>
          <OrganizationForm formik={formik} />
        </Modal>
      </form>
    </Container>
  );
};

export default Attendance;
